import(/* webpackMode: "eager" */ "/opt/build/repo/app/vad-ar-enrumsventilation/page.tsx");
